angular.module('ui-ng-draggable').service('phxDraggableService', function () {
  var drakes = {};

  this.addContainer = function (container, identifier, nonDraggableTag) {
    if (_.isUndefined(drakes[identifier])) {
      drakes[identifier] = dragula({
        revertOnSpill: true,
        invalid: function (el, handle) {
          return (
            el.tagName === nonDraggableTag ||
            (_.has(el.attributes, 'phx-draggable') && el.attributes['phx-draggable'].value === 'false')
          );
        }
      });
    }

    drakes[identifier].containers.push(container);
  };

  this.removeContainer = function (container, identifier) {
    if (_.isUndefined(drakes[identifier])) {
      return;
    }
    const index = drakes[identifier].containers.findIndex((el) => el instanceof Element && el.isSameNode(container));
    if (index >= 0) {
      drakes[identifier].containers.splice(index);
    }
  };

  this.getDrake = function (identifier) {
    return drakes[identifier];
  };

  this.getAllDrakes = function () {
    return drakes;
  };

  this.clearDrake = function (identifier) {
    drakes[identifier] = undefined;
  };
});



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-draggable/src/service/dragula_service.js